import React from "react";
import PropTypes from "prop-types";

import { Calendar as MultiDateCalendar } from "react-multi-date-picker";

import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

const Calendar = ({ date, onDateChanged }) => {
  return (
      <div className="custom-calendar">
        <MultiDateCalendar
            value={date}
            calendar={persian}
            locale={persian_fa}
            onChange={(value) => {
              if (!value) return;

              onDateChanged?.(
                  value.format("YYYY-MM-DD")
                      .replace(/۰/g, "0")
                      .replace(/۱/g, "1")
                      .replace(/۲/g, "2")
                      .replace(/۳/g, "3")
                      .replace(/۴/g, "4")
                      .replace(/۵/g, "5")
                      .replace(/۶/g, "6")
                      .replace(/۷/g, "7")
                      .replace(/۸/g, "8")
                      .replace(/۹/g, "9")
              );
            }}
        />

        <style>{`
                .custom-calendar{
                  display: flex;
                  justify-content: center;
                }
                .custom-calendar .rmdp-wrapper {
                    border: none !important;
                    box-shadow: none !important;
                }

                .custom-calendar .rmdp-day.rmdp-selected span {
                    background: #8A0FFF !important;
                }

                .custom-calendar .rmdp-week-day {
                    color: #8A0FFF !important;
                    font-weight: 600;
                }

                .custom-calendar .rmdp-header-values {
                    color: #8A0FFF !important;
                    font-weight: 700;
                }

                .custom-calendar .rmdp-arrow {
                    border-color: #8A0FFF !important;
                }

                .custom-calendar .rmdp-arrow-container:hover {
                    background: rgba(138,15,255,.1) !important;
                }
                .rmdp-day.rmdp-today span {
                      background-color: #fff !important; 
                      color: #8a0fff;
                 }
            `}</style>
      </div>
  );
};

Calendar.propTypes = {
  date: PropTypes.any,
  onDateChanged: PropTypes.func,
};

export default Calendar;